class FaqBlock extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.toggle = this.querySelector("[data-toggle]");
    this.content = this.querySelector("[data-content]");

    this.toggle.addEventListener("click", this.handleToggle);

    if (this.classList.contains("is-open")) {
      this.content.style.maxHeight = "none";
    }
  }

  disconnectedCallback() {
    this.toggle.removeEventListener("click", this.handleToggle);
  }

  handleToggle() {
    const isOpen = this.classList.contains("is-open");

    if (isOpen) {
      const fullHeight = this.content.scrollHeight;
      this.content.style.maxHeight = fullHeight + "px";
      requestAnimationFrame(() => {
        this.content.style.maxHeight = "0";
        this.classList.remove("is-open");
      });
    } else {
      this.classList.add("is-open");
      const fullHeight = this.content.scrollHeight;
      this.content.style.maxHeight = fullHeight + "px";

      this.content.addEventListener(
        "transitionend",
        () => {
          if (this.classList.contains("is-open")) {
            this.content.style.maxHeight = "none";
          }
        },
        { once: true }
      );
    }
  }
}

if (!customElements.get("faq-block")) {
  customElements.define("faq-block", FaqBlock);
}
